var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sortedCategories.length)?_c('apexchart',{attrs:{"type":"bar","height":Math.max(300, _vm.sortedCategories.length * 44 + 80),"options":_vm.opts,"series":_vm.series}}):_c('empty-state',{attrs:{"icon":"mdi-tag-multiple-outline","title":_vm.$t('no_data')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }